export default function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

/* Ejected from <https://github.com/formio/formio.js/blob/v4.12.7/src/templates/bootstrap/survey/form.ejs> to fix a bug w/ the radio button IDs not being unique. */;
__p += '\n\n';
/*
 * This is a bit of a hack. When multiple committee reviews are shown read-only, the forms are wrapped in a div instead
 * of a form tag. This means ALL radios, across all review forms, are part of the same radio group. Breaking them out
 * this way fixes that.
*/;
__p += '\n';
 if (ctx.disabled) { ;
__p += '\n<form id="survey-grouping-form-' +
((__t = (ctx.id)) == null ? '' : __t) +
'" action="#"></form>\n';
 } ;
__p += '\n\n<table class="table table-striped table-bordered">\n    <thead>\n    <tr>\n        <th></th>\n        ';
 ctx.component.values.forEach(function(value) { ;
__p += '\n        <th style="text-align: center;">' +
((__t = (ctx.t(value.label))) == null ? '' : __t) +
'</th>\n        ';
 }) ;
__p += '\n    </tr>\n    </thead>\n    <tbody>\n    ';
 ctx.component.questions.forEach(function(question) { ;
__p += '\n    <tr>\n        <td>' +
((__t = (ctx.t(question.label))) == null ? '' : __t) +
'</td>\n        ';
 ctx.component.values.forEach(function(value) { ;
__p += '\n        <td style="text-align: center;">\n            <input type="radio" name="' +
((__t = ( ctx.self.getInputName(question) )) == null ? '' : __t) +
'" value="' +
((__t = (value.value)) == null ? '' : __t) +
'" id="' +
((__t = (ctx.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.key)) == null ? '' : __t) +
'-' +
((__t = (question.value)) == null ? '' : __t) +
'-' +
((__t = (value.value)) == null ? '' : __t) +
'" ref="input" ';
 if (ctx.disabled) { ;
__p += ' form="survey-grouping-form-' +
((__t = ( ctx.id )) == null ? '' : __t) +
'" ';
 } ;
__p += '>\n        </td>\n        ';
 }) ;
__p += '\n    </tr>\n    ';
 }) ;
__p += '\n    </tbody>\n</table>\n';
return __p
}